import Message from './Message';

const message = "This tool can only be used by active employees. If you think you have received this message in error please reach out to HR.";

const Inactive = () => {
  return <Message message={message} />;
};

export default Inactive;
